import { type DisciplineDischargePlanViewModel } from '@generated';

export function DisciplineDischargePlan({ dischargePlan }: { dischargePlan: DisciplineDischargePlanViewModel }) {
	return (
		<div key={dischargePlan.disciplineId} className="flex items-start gap-2">
			<span className="mt-1.5 size-1.5 shrink-0 rounded-full bg-green-600" />
			<span className="text-sm text-gray-700">
				{`${dischargePlan.disciplineAbbreviation}: ${
					dischargePlan.reasonForNoPlannedDischarge ?? dischargePlan.disciplineDischargeGoal ?? 'N/A'
				}`}
			</span>
		</div>
	);
}
